import { AppState } from 'src/app/store'

export const getFleetSelector = (state: AppState) => state.cabifyProcess.fleetState
export const getCalculateFootprintSelector = (state: AppState) => state.cabifyProcess.calculateFootprint
export const downloadFileSelector = (state: AppState) => state.cabifyProcess.downloadFile


export const fleetFormValue = (state: AppState, fleetId?: number) => {
  if (fleetId){
    const fleetData = state.cabifyProcess.fleetState.data
    const formData = fleetData.filter(fleet => fleet.id === fleetId)[0]
    return {
      id: formData.id,
      country: formData.country,
      period: formData.period,
      fleetFile: formData.file,
    }
  }
}
